import React, { useEffect, useState } from 'react';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { AppSidebar } from 'components/fragment';
import { ContactSupport } from 'components/modals';

export default function SidebarLayout({ children }: { children: React.ReactNode }) {
  const [openSupportModal, setOpenSupportModal] = useState(false);

  useEffect(() => {
    const handleOpenContactSupport = () => {
      setOpenSupportModal(true);
    };
    window.addEventListener('open-contact-support', handleOpenContactSupport);
    return () => window.removeEventListener('open-contact-support', handleOpenContactSupport);
  }, []);

  const onOpenSupportModal = (value: boolean) => {
    setOpenSupportModal(value);
  };

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <main className={'ci:flex-1 ci:flex ci:flex-col ci:overflow-hidden'}>{children}</main>
      </SidebarInset>
      {openSupportModal && (
        <ContactSupport open={openSupportModal} onOpenChange={onOpenSupportModal} />
      )}
    </SidebarProvider>
  );
}
